import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'telxl-tag',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    host: {
        '[class]': 'class || ""',
    },
})
export class TelXLTagComponent {
    text = input.required<string>();
    icon = input<string>();
    colour = input<string>();
    outline = input<boolean>(false);
}
